/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetingType } from '../../models/meeting-type';

export interface GetAllMeetingTypes$Json$Params {
}

export function getAllMeetingTypes$Json(http: HttpClient, rootUrl: string, params?: GetAllMeetingTypes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MeetingType>>> {
  const rb = new RequestBuilder(rootUrl, getAllMeetingTypes$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MeetingType>>;
    })
  );
}

getAllMeetingTypes$Json.PATH = '/api/MeetingType';
